import { Controller } from "@hotwired/stimulus"

// Toggles all checkboxes inside an Academy tag category card.
export default class extends Controller {
  static targets = ["checkbox", "button", "card", "cardCheckbox"]
  static values = {
    selectLabel: { type: String, default: "Tout cocher" },
    deselectLabel: { type: String, default: "Tout décocher" },
  }

  connect() {
    this.refresh()
  }

  toggle(event) {
    event.preventDefault()
    const checked = !this.allChecked
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
    this.refresh()
    this.notifyChange(this.checkboxTargets[0])
  }

  toggleCard(event) {
    const card = event.target.closest("[data-academy-tag-group-target~='card']")
    if (!card) return

    const checkboxes = this.cardCheckboxesFor(card)
    checkboxes.forEach((checkbox) => {
      checkbox.checked = event.target.checked
    })
    this.refresh()
    this.notifyChange(checkboxes[0])
  }

  refresh() {
    this.refreshButtonLabel()
    this.refreshCardCheckboxes()
  }

  refreshButtonLabel() {
    if (!this.hasButtonTarget) return

    this.buttonTarget.textContent = this.allChecked ? this.deselectLabelValue : this.selectLabelValue
  }

  refreshCardCheckboxes() {
    this.cardCheckboxTargets.forEach((cardCheckbox) => {
      const card = cardCheckbox.closest("[data-academy-tag-group-target~='card']")
      if (!card) return

      const checkboxes = this.cardCheckboxesFor(card)
      const checkedCount = checkboxes.filter((checkbox) => checkbox.checked).length

      cardCheckbox.checked = checkboxes.length > 0 && checkedCount === checkboxes.length
      cardCheckbox.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length
    })
  }

  // Un seul évènement suffit : les contrôleurs voisins rechargent le corpus Notion à chaque change.
  notifyChange(checkbox) {
    if (!checkbox) return

    checkbox.dispatchEvent(new Event("change", { bubbles: true }))
  }

  cardCheckboxesFor(card) {
    return this.checkboxTargets.filter((checkbox) => card.contains(checkbox))
  }

  get allChecked() {
    return this.checkboxTargets.length > 0 && this.checkboxTargets.every((checkbox) => checkbox.checked)
  }
}
